<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconBackspace_16"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.87 3.174c.163-.11.36-.174.57-.174h8.526C14.537 3 15 3.47 15 4.05v8.4c0 .58-.463 1.05-1.034 1.05H5.44c-.147 0-.288-.032-.415-.089a.85.85 0 0 1-.1-.042c-.237-.12-.652-.604-.952-.954l-.082-.096-2.66-3.347a1.063 1.063 0 0 1-.012-1.304L3.89 4.18c.087-.089.178-.198.274-.314.202-.245.43-.52.706-.693Zm6.923 7.62a.7.7 0 0 1-.99 0L9.15 9.138l-1.654 1.654a.7.7 0 1 1-.99-.99L8.159 8.15 6.505 6.495a.7.7 0 1 1 .99-.99l1.654 1.654 1.654-1.654a.7.7 0 1 1 .99.99L10.14 8.149l1.654 1.654a.7.7 0 0 1 0 .99Z"
        fill="currentColor"
    />
</svg>
